import React from 'react'
import LinkAnimate from 'utils/hooks/linkAnimate'

function CardCaseStudy(props) {
  const { data } = props.data

  const company = data?.company?.document.data

  return (
    <LinkAnimate className={`card-cs ${props.className || ''}`} to={`case-study/${props.slug}`}>
      <div className="mb-1">
        {company && (
          <img
            className="card-cs__logo img-disabled mb-1"
            loading="lazy"
            src={company.logo.url}
            alt={data.company.document.data.name.text}
          />
        )}
        <h3 className="h4 ft-500 c-text-black-lighter">“{data.title ? data.title.text : data.quote.text}”</h3>
      </div>
      <div className="card-cs__author">
        <div className="author__picture">
          <img
            className="img-disabled "
            loading="lazy"
            src={data.author.document.data.picture.url}
            alt={data.author.document.data.name.text}
          />
        </div>
        <div>
          <h4 className="ft-secondary c-text-black-lighter ft-600">
            {data.author.document.data.name.text}, {data.author.document.data.role.text}
          </h4>
        </div>
      </div>
    </LinkAnimate>
  )
}

export default CardCaseStudy
